import { render, staticRenderFns } from "./base-performance.vue?vue&type=template&id=3bbd74cf&"
import script from "./base-performance.vue?vue&type=script&lang=js&"
export * from "./base-performance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports